import React, { Component } from 'react';
import Layout from '../../shared/components/layouts/MainLayout';
import Statistics from '../components/Statistics'
import Header from '../components/Header'
import axios from 'axios';
import {showNotification} from "../../../utils/toast";
import OpportunitiesTable from '../../projectFinder/components/OpportunitiesTable';
import {debounce} from 'lodash-es'
import { Link } from 'react-router-dom';

export class ProjectFinderLandingPage extends Component {
  constructor(props){
    super(props)
    this.state = {
      openBidsCount: 0,
      newBidsCount: 0,
      openBidsValue: 0,
      opportunities: [],
      loading: true,
      keyword: "",
      regions: [],
      min_amount: "",
      max_amount: "",
      sort_params: {sort_key: "", sort_direction: "DESC"},
      error: {},
    }

    this.fetchPageData = this.fetchPageData.bind(this);
    this.handleSort = debounce(this.handleSort.bind(this), 300);
    this.handleChange = this.handleChange.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
    this.handleAmountKeypress = this.handleAmountKeypress.bind(this);
    this.handleClickButton = this.handleClickButton.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    })
  };

  handleValueChange(value, name) {
    this.setState({
      [name]: value
    })
  };

  multiSelectOnChange(selectedList) {
    this.setState({regions: selectedList});
  }

  handleAmountKeypress(event) {
    if (["-", "e"].includes(event.key)) {
      event.preventDefault()
    }
  }

  componentWillMount() {
    this.fetchPageData();
  }

  async fetchPageData() {
    const url = `${process.env.REACT_APP_IE_API_BASE_URL}/project_finder/landing_page`;

    axios(
      url,
      {
        params: { sort_params: this.state.sort_params },
        method: "GET",
      }
    )
    .then(response => {
      const data = response.data;

      this.setState({
        newBidsCount: data.new_bids_count,
        openBidsValue: data.open_bids_value,
        openBidsCount: data.open_bids_count,
        opportunities: data.opportunities,
        loading: false
      })
    })
    .catch(errors => {
      const errorMessage = errors.message;
      showNotification("error", errorMessage);
    })
  }
  handleClickButton() {
    const {keyword, regions, min_amount, max_amount} = this.state;

    const searchParams = {
      keyword: keyword,
      regions: regions,
      min_amount: min_amount,
      max_amount: max_amount
    }
    const urlParams = new URLSearchParams(searchParams).toString();

    const path = `project-finder/search?${urlParams}`;
    window.open(path,'_blank');
  }

  handleSort(key) {
    const {sort_key, sort_direction} = this.state.sort_params;
    let new_direction = sort_direction;

    if (key === sort_key) {
      new_direction = sort_direction === "ASC" ? "DESC" : "ASC"
    }

    this.setState({
      loading: true,
      sort_params: {
        sort_key: key,
        sort_direction: new_direction
      }
    })

    this.fetchPageData();
  }

  render(){
    return(
      <Layout gridClassName='grid --fullWidth'>
        <Header
          handleChange={this.handleChange}
          handleValueChange={this.handleValueChange}
          multiSelectOnChange={this.multiSelectOnChange}
          handleAmountKeypress={this.handleAmountKeypress}
          handleClickButton={this.handleClickButton}
        />
        <Statistics
          openBidsCount={this.state.openBidsCount}
          newBidsCount={this.state.newBidsCount}
          openBidsValue={this.state.openBidsValue}
        />
        <div className="opportunities-section">
          <OpportunitiesTable
            loading = {this.state.loading}
            opportunities={this.state.opportunities}
            sort_params={this.state.sort_params}
            handleSort={this.handleSort}
            hidePagination={true}
          />
          <Link
            to={{pathname: "/project-finder/search"}}
            data-testid="opportunities-button"
            className="ds-btn --medium --full _padding--small"
          >
            See full list of government projects
          </Link>
        </div>
        <div className="faqs-section">
          <iframe
            src="https://www.firstcircle.ph/first-circle-project-finderv2"
            title="FAQs"
          />
        </div>
      </Layout>
    )
  }
}

export default ProjectFinderLandingPage;



// WEBPACK FOOTER //
// ./src/features/projectFinderLandingPage/containers/ProjectFinderLandingPage.js